import React from 'react';

interface DrinksComponentProps {
    onTransportClick: () => void;
    onLodgingClick: () => void;
    showLodging: boolean;
}

const DrinksComponent: React.FC<DrinksComponentProps> = ({ onTransportClick, onLodgingClick, showLodging }) => {

  return (
    <div className="min-h-lvh relative flex flex-col justify-center items-center text-white text-center">
        <p className="mt-10">Contaremos con un menú de bebidas alcohólicas y no alcohólicas apto para todos los gustos, pero...</p>
        <p className="mt-10 font-bold">¿Tienes gustos especiales o eres de carrera larga?</p>
        <div className="relative md:mt-0 mt-7">
            <img src={"images/Bebidas.png"} alt={"Drinks"} className={"md:w-[85%] ml-2 inline-block object-center"}/>
            <div className="absolute top-17 left-10 md:top-30 md:left-25 w-[65%]">
                <p className="font-bold text-center md:text-xl text-(--primary-color)">Trae tus botellas favoritas</p>
                <p className="mt-3 text-(--primary-color)">Si tienes una botella especial que te gustaría consumir o compartir con tu mesa ¡adelante! Puedes traer tus bebidas favoritas para complementar nuestra selección.<br/>Nuestro abasto será básico.</p>
                <p className="md:text-left italic mt-19 md:w-[80%] md:text-(--primary-color) text-white md:leading-6 leading-4">Tip: Etiqueta tu botella con el nombre de tu mesa para evitar confusiones. ¡Nuestro staff te ayudará a servirla!</p>
            </div>
        </div>
        <p className="text-xl font-semibold md:mt-5 mt-30">Recuerda:</p>
        <div className="pt-4 grid grid-flow-col grid-cols-2 grid-rows-1 gap-7 mb-20">
            <div className="static md:h-40 h-57">
                <div className="bg-[#4c6a4d] h-full rounded-4xl">
                    <p className="pt-6 font-bold text-lg">Con moderación</p>
                    <p className="p-4 font-light">Disfruta responsablemente para que todos tengamos una noche memorable.</p>
                </div>
                <img src={"images/Mojito.png"} alt={"Drinks"} className={"md:w-[50%] w-[80%] object-cover md:-mt-10 -mt-8 md:ml-10 ml-6"}/>
            </div>
            <div>
                <div className="bg-[#4c6a4d] rounded-4xl">
                    <p className="pt-6 font-bold text-lg">NO manejes</p>
                    <p className="p-4 font-light">Si planeas beber, asegúrate de tener transporte seguro de regreso o
                        considera pasar la noche en el glamping.</p>
                </div>
                <div className="mt-10 underline cursor-pointer" onClick={onTransportClick}>Ver opciones de transporte</div>
                {showLodging && <div className="mt-5 underline cursor-pointer" onClick={onLodgingClick}>Ver opciones de hospedaje</div>}
            </div>
        </div>
    </div>
  );
};

export default DrinksComponent;
